export default __webpack_public_path__ + "static/media/pic2.db43734e.jpg";